module.exports = __webpack_public_path__ + "img/banner-37.4e9e51f8.jpg";